const OPTIONS = [
  { value: "hidden", label: "Hidden", sub: "Only you see responses" },
  { value: "yes", label: "Yes only", sub: "Show who's going" },
  { value: "yes_maybe", label: "Yes and Maybe", sub: "Going + maybe" },
  { value: "all", label: "All responses", sub: "Yes, Maybe, No" },
];

export const GuestVisibilityPicker = ({ value, onChange }) => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" role="radiogroup" data-testid="guest-visibility-select">
    {OPTIONS.map(({ value: v, label, sub }) => (
      <button
        key={v}
        type="button"
        role="radio"
        aria-checked={value === v}
        data-testid={`guest-visibility-${v}`}
        onClick={() => onChange(v)}
        className={`rounded-xl border-2 px-3 py-3 text-left transition-[background-color,border-color] duration-200 ${
          value === v ? "border-blue-700 bg-blue-50 text-blue-800" : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
        }`}
      >
        <span className="block text-sm font-bold">{label}</span>
        <span className="block text-xs opacity-75">{sub}</span>
      </button>
    ))}
  </div>
);
